export default "__VITE_ASSET__CgViqIrF__"